(function() {
  function initStaffel() {
    var dataEl = document.getElementById('variant-staffel-data');
    var priceDisplay = document.querySelector('[data-js-product-price-original]');
    var compareDisplay = document.querySelector('[data-js-product-price-compare]');
    var discountBadge = document.querySelector('[data-js-product-price-discount]');
    var qtyInput = document.querySelector('input[name="quantity"].product-quantity__selector');
    var selectionTextEl = document.getElementById('dynamic-selection-text');
    var summaryContainer = document.getElementById('selection-summary');
    
    // Bildelemente selektieren
    var img1 = document.getElementById('staffel-img-1');
    var img2 = document.getElementById('staffel-img-2');
    var img3 = document.getElementById('staffel-img-3');
    
    if (!dataEl || !priceDisplay) return;

    var staffelData;
    try {
      staffelData = JSON.parse(dataEl.textContent || dataEl.innerHTML);
    } catch (e) {
      console.error('Staffel JSON parse error', e);
      return;
    }

    var container = document.querySelector('.staffel-container');
    var boxes = Array.from(document.querySelectorAll('.staffel-box'));
    var variantPrices = {}; 
    var variantComparePrices = {}; 
    var titleToId = {};

    var variantsScript = document.querySelector('product-variants script[type="application/json"]');
    if (variantsScript) {
      try {
        var variantsJson = JSON.parse(variantsScript.textContent || variantsScript.innerHTML);
        variantsJson.forEach(function(variant) {
          titleToId[variant.title] = String(variant.id);
          variantPrices[String(variant.id)] = parseFloat(variant.price); 
          variantComparePrices[String(variant.id)] = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
        });
      } catch (e) {
        console.warn('Konnte Theme-Varianten-JSON nicht parsen', e);
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function unlockMinusButton() {
      var minusBtn = document.querySelector('.product-quantity__minus');
      if (minusBtn && qtyInput && parseInt(qtyInput.value) > 1) {
        minusBtn.classList.remove('disabled');
        minusBtn.removeAttribute('disabled');
      }
    }

    function syncBoxesFromQuantity() {
      if (!qtyInput) qtyInput = document.querySelector('input[name="quantity"].product-quantity__selector');
      if (!qtyInput) return;

      var val = parseInt(qtyInput.value) || 1;
      boxes.forEach(function(box) { box.classList.remove('is-active'); });
      
      if (val === 1 && boxes[0]) boxes[0].classList.add('is-active');
      else if (val === 2 && boxes[1]) boxes[1].classList.add('is-active');
      else if (val >= 3 && boxes[2]) boxes[2].classList.add('is-active');
      
      updateTotalPrice();
    }

    function updateTotalPrice() {
      var currentId = getCurrentVariantIdFromRadios();
      var basePrice = variantPrices[currentId];
      var baseComparePrice = variantComparePrices[currentId];
      
      if (!basePrice) return;
      if (!qtyInput) qtyInput = document.querySelector('input[name="quantity"].product-quantity__selector');

      var quantity = parseInt(qtyInput.value) || 1;
      var discountIndex = Math.min(quantity - 1, 2);

      var discountTable = {
        'option_01': [0, 0.05, 0.10],
        'option_02': [0, 0.10, 0.15]
      };

      var staffelDiscount = 0;
      var config = staffelData[currentId];
      
      // Logik-Check (config.logic statt config, da das JSON nun Objekte enthält)
      if (config && config.logic && config.logic !== 'off') {
        var activeKey = Array.isArray(config.logic) ? config.logic[0] : config.logic;
        if (discountTable[activeKey]) {
          staffelDiscount = discountTable[activeKey][discountIndex] || 0;
        }
      }

      var totalWithoutStaffel = basePrice * quantity;
      var staffelDiscountAmount = Math.ceil(totalWithoutStaffel * staffelDiscount); 
      var finalPriceCents = totalWithoutStaffel - staffelDiscountAmount;
      
      priceDisplay.innerText = formatMoney(finalPriceCents);

      if (selectionTextEl) {
        var activeVariantInput = document.querySelector('.product-variant__input.product-variant-value:checked');
        var variantName = activeVariantInput ? activeVariantInput.value : "";
        selectionTextEl.innerText = quantity + ' x ' + variantName;
      }

      if (discountBadge) {
        var shopifyDiscount = 0;
        if (baseComparePrice && baseComparePrice > basePrice) {
          shopifyDiscount = (baseComparePrice - basePrice) / baseComparePrice;
        }
        var totalDiscountFactor = 1 - ((1 - shopifyDiscount) * (1 - staffelDiscount));
        var totalDiscountPercent = Math.round(totalDiscountFactor * 100);

        if (totalDiscountPercent > 0) {
          discountBadge.innerText = '-' + totalDiscountPercent + '%';
          discountBadge.style.display = 'inline-block';
        } else {
          discountBadge.style.display = 'none';
        }
      }

      if (compareDisplay) {
        var effectiveCompareBase = (baseComparePrice && baseComparePrice > basePrice) ? baseComparePrice : basePrice;
        var totalCompareDisplay = effectiveCompareBase * quantity;

        if (staffelDiscount > 0 || (baseComparePrice && baseComparePrice > basePrice)) {
          compareDisplay.innerText = formatMoney(totalCompareDisplay);
          compareDisplay.style.display = 'inline-block';
        } else {
          compareDisplay.style.display = 'none';
        }
      }
    }

    function updateUI(vId) {
  var idStr = String(vId);
  var config = staffelData[idStr];
  var b2 = document.getElementById('badge-2');
  var b3 = document.getElementById('badge-3');

  // Sicherstellen, dass config existiert
  if (!config) {
    hideStaffel();
    return;
  }

  // Präzise Prüfung für Listen (Arrays)
  var logicArray = Array.isArray(config.logic) ? config.logic : [];
  var firstOption = logicArray[0] || null;

  // Nur anzeigen, wenn option_01 oder option_02 wirklich drinsteht
  var hasValidLogic = (firstOption === 'option_01' || firstOption === 'option_02');

  if (hasValidLogic) {
    // 1. Bilder aktualisieren
    if (config.img1 && img1) img1.src = config.img1;
    if (config.img2 && img2) img2.src = config.img2;
    if (config.img3 && img3) img3.src = config.img3;
    
    // 2. Sichtbarkeit auf flex setzen
    container.style.setProperty('display', 'flex', 'important');
    if (summaryContainer) {
      summaryContainer.style.setProperty('display', 'block', 'important');
    }

    // 3. Badges aktualisieren
    if (firstOption === 'option_01') {
      if (b2) b2.innerText = '-5%';
      if (b3) b3.innerText = '-10%';
    } else if (firstOption === 'option_02') {
      if (b2) b2.innerText = '-10%';
      if (b3) b3.innerText = '-15%';
    }
  } else {
    hideStaffel();
  }

  function hideStaffel() {
    if (container) container.style.setProperty('display', 'none', 'important');
    if (summaryContainer) summaryContainer.style.setProperty('display', 'none', 'important');
  }

  updateTotalPrice();
}

    boxes.forEach(function(box, idx) {
      box.addEventListener('click', function() {
        if (qtyInput) {
          qtyInput.value = idx + 1;
          if (idx + 1 > 1) unlockMinusButton();
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          syncBoxesFromQuantity();
        }
      });
    });

    var qtyComp = document.querySelector('product-quantity');
    if (qtyComp) {
      qtyComp.addEventListener('click', function(e) {
        var btn = e.target.closest('button');
        if (btn) {
           setTimeout(function() {
             syncBoxesFromQuantity();
             unlockMinusButton();
           }, 150); 
        }
      }, true);

      qtyComp.addEventListener('change', function() {
        setTimeout(syncBoxesFromQuantity, 50);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', syncBoxesFromQuantity);
    }

    function getCurrentVariantIdFromRadios() {
      var checked = document.querySelector('.product-variant__input.product-variant-value:checked');
      if (checked && titleToId[checked.value]) return titleToId[checked.value];
      var idInp = document.querySelector('form[action="/cart/add"] input[name="id"]');
      return idInp ? idInp.value : (dataEl.dataset.defaultVariantId || null);
    }

    var initialId = getCurrentVariantIdFromRadios();
    if (initialId) updateUI(initialId);
    syncBoxesFromQuantity();
    
    document.addEventListener('change', function(e) {
      if (e.target && e.target.classList.contains('product-variant__input')) {
        var newId = getCurrentVariantIdFromRadios();
        if (newId) updateUI(newId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStaffel);
  } else {
    initStaffel();
  }
})();